import React, { Component } from "react";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { FaArrowLeft, FaRegStickyNote, FaFilePdf, FaPaperclip, FaTimes, FaTrash } from 'react-icons/fa';
import { Col, Row, Form, Button, Spinner } from "react-bootstrap";
import { hasPerm, getCurrentUser } from '../../common/utils';
import logomarca from '../../assets/images/logo3_resize.png';
import TermosAcceptModal from '../Modals/TermosAcceptModal';
import "@whereby.com/browser-sdk/embed";

class MeetingsEdit extends Component {
    constructor(props) {
        super(props);

        this.handleChangeAnotacoes = this.handleChangeAnotacoes.bind(this);

        this.onChangeProtocolo = this.onChangeProtocolo.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            agendamento_id: '',
            data_agendamento: '',
            beneficiario_id: '',
            prestador_id: '',
            mentorado_id: '',
            situacao: '',
            host_url: '',
            guest_url: '',
            sala_id: '',
            possui_chamada_video: '',
            loading: false,
            erroLoadRegistro: '',
            slideOpen: false,
            activeSlide: null, // null, 'anotacoes', 'arquivos', 'protocolo'
            anotacoes: '',
            isSaving: false,
            protocolo_upload: '',
            protocolo: '',
            protocoloHelper: "",
            agendamentoEncontrado: true,
            arquivo_upload: '',
            arquivo: '',
            arquivo_nome: '',
            arquivos: [],
            dados_usuario: '',
            isHost: false,
            //o gate de termos do TopNavigation nao alcanca a sala: ao entrar em tela cheia
            //o App troca para as rotas de fullscreen e a barra superior desmonta. Quem chega
            //pelo link do e-mail entraria sem aceitar nada, entao a sala tem o proprio gate.
            verificandoTermos: true,
            termosPendentes: [],
        };
    }

    //Mentor e mentorado so entram na sala depois de aceitar os termos do programa (PDF
    //cadastrado em Termos da Plataforma com o programa no escopo).
    verificaTermosPendentes = async () => {
        const dados_user = getCurrentUser();
        const programaId = dados_user?.ambiente_programa_id;

        if (!programaId) {
            this.setState({ verificandoTermos: false });
            return [];
        }

        try {
            const response = await api.get('/termos-plataforma/termos-pendentes/', {
                params: { programa: programaId, categoria: dados_user?.prestador_categoria },
            });

            //mesma defesa do TopNavigation: termo com escopo de programa nao vaza para outro
            const termosDoPrograma = (response.data || []).filter(termo => {
                const escopo = Array.isArray(termo?.programas) ? termo.programas.map(Number) : [];
                return escopo.length === 0 || escopo.includes(Number(programaId));
            });

            this.setState({ termosPendentes: termosDoPrograma, verificandoTermos: false });

            return termosDoPrograma;
        } catch (error) {
            console.error('Erro ao verificar termos pendentes da sala:', error);
            //falha na verificacao nao pode trancar a sala: a sessao ja esta marcada
            this.setState({ verificandoTermos: false });
            return [];
        }
    };

    handleTermosAceitos = () => {
        this.setState({ termosPendentes: [] }, () => {
            this.iniciaSala();
        });
    };

    handleTermosRecusados = () => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            icon: 'warning',
            title: 'Aceite obrigatório',
            text: 'O aceite dos termos é obrigatório para participar da mentoria.',
            confirmButtonText: 'Ok, entendi',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(() => {
            window.location.href = '/agendamentos';
        });
    };

    componentDidMount(){
        const id = this.props.router.params.id;

        //Limpa sessão de url de redirecionamento
        sessionStorage.removeItem("redirectAfterLogin");

        const dados_user = getCurrentUser();

        this.setState({
            dados_usuario: dados_user,
            agendamento_id: id,
        })

        //Tela cheia primeiro: isso desmonta o TopNavigation, que tem o proprio gate de
        //termos. Sem isso os dois modais apareceriam ao mesmo tempo para o mesmo aceite.
        this.props.toggleFullScreenMode(true);

        //A sala so abre depois do aceite: sem termo pendente entra direto, com termo
        //pendente quem libera e o handleTermosAceitos.
        this.verificaTermosPendentes().then(termos => {
            if (termos.length === 0) {
                this.iniciaSala();
            }
        });
    }

    iniciaSala = () => {
        const id = this.props.router.params.id;
        const dados_user = getCurrentUser();

        this.setState({
            loading: true,
            erroLoadRegistro: ''
        })

        if(id){
            //consulta os dados do agendamento na api
            api.get(`/agendamentos/${id}`)
            .then(response => {
                const dados = response.data;
                
                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    data_agendamento: dados.data_agendamento,
                    beneficiario_id: dados.beneficiario_id,
                    prestador_id: dados.prestador_id,
                    mentorado_id: dados.mentorado_id,
                    operador_id: dados.operador_id,
                    situacao: dados.situacao || '',
                    possui_chamada_video: dados.possui_chamada_video,
                    anotacoes: dados.anotacoes,
                    protocolo: dados.protocolo,
                    host_url: dados.dados_meeting?.whereby_sala_host_url,
                    guest_url: dados.dados_meeting?.whereby_sala_url,
                    sala_id: dados.dados_meeting?.whereby_sala_id,
                    loading: false
                }, () => {
                    let isHost = false;

                    //prestador
                    if(dados_user.tipo_usuario === 'prestador'){
                        isHost = dados_user.prestador_id === this.state.prestador_id;
                    }
                    //navegador
                    else if(dados_user.tipo_usuario === 'operador') {
                        isHost = dados_user.operador_id === this.state.operador_id;
                    }

                    this.setState({ isHost });

                    // Cria o embed da sala Whereby com base no tipo de usuário
                    //this.initWherebyEmbed(isHost ? dados.dados_meeting?.whereby_sala_host_url : dados.dados_meeting?.whereby_sala_url);
                    this.carregaArquivosAgendamento();
                })     
                
                
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar agendamento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    agendamentoEncontrado: false,
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                carteira_id: '',
                titulo_pagina: 'Adicionar Agendamento',
                loading: false,
                erroLoadRegistro: '',
            })
        }

        // Adiciona o ouvinte para o evento "leave"
        const elm = document.querySelector("whereby-embed");
        if (elm) {
            elm.addEventListener("leave", this.handleLeave);
        }
    }

    componentWillUnmount() {
        // Remove o ouvinte de evento ao desmontar o componente
        const elm = document.querySelector("whereby-embed");
        if (elm) {
            elm.removeEventListener("leave", this.handleLeave);
        }

        // Desativa o modo de tela cheia ao sair do componente
        this.props.toggleFullScreenMode(false);
    }

    carregaArquivosAgendamento = () => {
        if (this.state.agendamento_id) {
            api.get(`/agendamentos/arquivos/?agendamento_id=${this.state.agendamento_id}`)
                .then(response => {
                    const arquivosCarregados = response.data.results.map(dados => ({
                        id: dados.id,
                        nome: dados.nome,
                        arquivo: dados.arquivo,
                        agendamento_id: dados.agendamento_id,
                        data: dados.data
                    }));
                    this.setState({ arquivos: arquivosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar arquivos:', error);
                    
                    let erro_msg = 'Erro ao carregar arquivos do agendamento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    handleLeave = (event) => {
        // Quando o host fecha a sala, chama a função para voltar para o painel
        this.handleBackToPanel();
    }

    /**
     * Encerrar a sala é o fim do atendimento na prática — é ali que o profissional sabe
     * que a sessão aconteceu. Em vez de esperar que ele lembre de procurar o agendamento
     * depois, a volta ao painel carrega o id em `?confirmar=`, e a tela de Agendamentos
     * abre o modal de confirmação da realização já preenchido.
     *
     * Só quem conduz a sala confirma, e só faz sentido em agendamento ainda aberto.
     */
    handleBackToPanel = () => {
        const encerrado = ['finalizado', 'cancelado'].includes(this.state.situacao);
        const podeConfirmar = this.state.isHost && !encerrado && this.state.agendamento_id;

        window.location.href = podeConfirmar
            ? `/agendamentos?confirmar=${this.state.agendamento_id}`
            : '/agendamentos';
    }

    toggleSlide = (slide) => {
        if (this.state.activeSlide === slide || slide === '') {
            this.setState({ slideOpen: false, activeSlide: '' });
        } else {
            this.setState({ slideOpen: true, activeSlide: slide });
        }
    }

    handleChangeAnotacoes = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    
        if (this.saveAnotacoesTimeout) {
            clearTimeout(this.saveAnotacoesTimeout);
        }
    
        this.saveAnotacoesTimeout = setTimeout(() => {
            this.saveAnotacoes();
        }, 1000); // Espera 1 segundo após o usuário parar de digitar
    }

    saveAnotacoes = () => {
        const { agendamento_id, anotacoes } = this.state;
        this.setState({ isSaving: true });
    
        api.put(`/agendamentos/${agendamento_id}/`, { anotacoes })
            .then(response => {
                // Tratar resposta de sucesso aqui, se necessário
            })
            .catch(error => {
                // Tratar erro aqui
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: "Atenção",
                    html: "Houve um erro ao tentar salvar a anotação, por favor tente atualizar a página"
                }).then((result) => {
                    
                });
            })
            .finally(() => {
                this.setState({ isSaving: false });
            });
    }

    saveProtocolo = (e) => {
        e.preventDefault();

        const formData = new FormData();

        const MySwal = withReactContent(Swal)

        const { agendamento_id, protocolo_upload } = this.state;
        
        this.setState({
            loading: true
        });

        if (!protocolo_upload) {
            this.setState({
                loading: false,
            });

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção",
                html: "Forneça um protocolo PDF para enviar"
            }).then((result) => {
                
            });

            return false;
        }

        const url = '/agendamentos/'+agendamento_id+'/';
        const metodo = 'put';

        formData.append('protocolo', this.state.protocolo_upload);
    
        api({
            method: metodo,
            url: url,
            data: formData
        }).then(response => {

                this.setState({
                    protocolo: response.data.protocolo
                })

                MySwal.fire({
                    title: 'Sucesso',
                    icon: 'success',
                    html: 'Protocolo enviado com sucesso',
                    showCloseButton: true,
                })

                this.setState({
                    loading: false,
                })
            })
            .catch(error => {
                let erro_msg = "Erro ao cadastrar protocolo, tente novamente<br><br>";            

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response && error.response.status === 400){
                    
                    //percorre os campos com erro
                    for (let key in campos){
                        var value = campos[key];

                        if(key === 'protocolo'){
                            erro_msg += value;
                        }
                    };
                }

                const MySwal = withReactContent(Swal)
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção!',
                    html: <p>{erro_msg}</p>,
                })    
                
                this.setState({
                    loading: false,
                })
            })
            .finally(() => {
                this.setState({ isSaving: false });
            });
    }

    onChangeProtocolo = (e) => {
        this.setState({ protocolo_upload: e.target.files[0] });
    };

    saveArquivo = (e) => {
        e.preventDefault();

        const formData = new FormData();

        const MySwal = withReactContent(Swal)

        const { agendamento_id, arquivo_upload } = this.state;
        
        this.setState({
            loading: true
        });

        if (!arquivo_upload) {
            this.setState({
                loading: false,
            });

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção",
                html: "Forneça um arquivo para enviar"
            }).then((result) => {
                
            });

            return false;
        }

        const url = '/agendamentos/arquivos/';
        const metodo = 'post';

        const agora = new Date();
        const dataHoraAtualFormatada = agora.toISOString().replace('T', ' ').substring(0, 19);

        formData.append('arquivo', this.state.arquivo_upload);
        formData.append('nome', this.state.arquivo_nome);
        formData.append('agendamento_id', agendamento_id);
        formData.append('data', dataHoraAtualFormatada);
        formData.append('aprovado', true);
        formData.append('tipo', 'laudo');
        formData.append('pessoa_id', 1);
    
        api({
            method: metodo,
            url: url,
            data: formData
        }).then(response => {

                this.setState({
                    protocolo: response.data.protocolo
                })

                MySwal.fire({
                    title: 'Sucesso',
                    icon: 'success',
                    html: 'Arquivo enviado com sucesso',
                    showCloseButton: true,
                })

                this.carregaArquivosAgendamento();

                this.setState({
                    loading: false,
                })
            })
            .catch(error => {
                let erro_msg = "Erro ao cadastrar arquivo, tente novamente<br><br>";            

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response && error.response.status === 400){
                    
                    //percorre os campos com erro
                    for (let key in campos){
                        var value = campos[key];

                        if(key === 'arquivo'){
                            erro_msg += value;
                        }
                    };
                }

                const MySwal = withReactContent(Swal)
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção!',
                    html: <p>{erro_msg}</p>,
                })    
                
                this.setState({
                    loading: false,
                })
            })
            .finally(() => {
                this.setState({ isSaving: false });
            });
    }

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            
            // Armazena o arquivo para upload
            this.setState({ arquivo_upload: arquivo_enviado });
            
            // Armazena o nome do arquivo para uso posterior, se necessário
            this.setState({ arquivo_nome: arquivo_enviado.name });
        }
    };

    excluirArquivo = (idArquivo) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir arquivo?',
            text: "Tem certeza que deseja excluir este arquivo? Você não poderá reverter isso!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/agendamentos/arquivos/${idArquivo}/`)
                    .then(response => {
                        MySwal.fire(
                            'Excluído!',
                            'O arquivo foi excluído com sucesso.',
                            'success'
                        );
                        // Remova o arquivo do estado para atualizar a UI
                        this.setState(prevState => ({
                            arquivos: prevState.arquivos.filter(arquivo => arquivo.id !== idArquivo),
                            loading: false
                        }));
                    })
                    .catch(error => {
                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar excluir o arquivo. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                    });
            }
        });
    }

    /*initWherebyEmbed = (url) => {
        // Agora, é necessário garantir que a instância de Whereby esteja acessível corretamente
        const room = new window.Whereby.Room(url); // Agora deve funcionar ao acessar o objeto via window.
    
        // Adiciona o embed na página
        room.embed({
          element: document.getElementById('whereby-embed'),  // Este é o elemento onde o embed será renderizado
          onLoad: () => console.log('Whereby carregado com sucesso'),
          onError: (error) => console.error('Erro ao carregar Whereby:', error),
        });
    }*/

    render(){
        const { slideOpen, activeSlide, agendamentoEncontrado, arquivos, verificandoTermos, termosPendentes } = this.state;

        //enquanto nao se sabe se ha termo pendente a sala nao pode aparecer, senao o
        //participante entra na chamada por baixo do modal
        if (verificandoTermos) {
            return (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    <Spinner animation="border" variant="primary" />
                </div>
            );
        }

        if (termosPendentes.length > 0) {
            return (
                <TermosAcceptModal
                    show={true}
                    termos={termosPendentes}
                    onAccept={this.handleTermosAceitos}
                    onDecline={this.handleTermosRecusados}
                />
            );
        }

        if (!agendamentoEncontrado) {
            return (
                <div className="centered-message">
                    <h2 className="mb-4">Agendamento não encontrado</h2>
                    <button className="btn btn-first" onClick={this.handleBackToPanel}>Voltar para Home</button>
                </div>
            );
        }

        return (
            <div className="app-container">
                {slideOpen && (
                    <div className="slide-panel open">
                        <button className="close-panel" onClick={() => this.toggleSlide('')}><FaTimes /></button>
                        <div className="meeting-slide-content">
                            <div className="meeting-slide-header">
                                <img className="meeting-slide-img" src={logomarca} alt="Aditus" />         
                            </div> 
                            {activeSlide == 'anotacoes' && (
                                <Form onSubmit={this.enviaAnotacoes}>
                                    <Row>
                                        <Col sm={12}>
                                            <h4 className="mb-3">Anotações</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Anotações deste atendimento</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Escreva suas anotações aqui" 
                                                    name="anotacoes"
                                                    value={this.state.anotacoes} 
                                                    onChange={this.handleChangeAnotacoes} 
                                                    className="custom-textarea"
                                                />    
                                                {this.state.isSaving && <div className="text-white">Salvando anotação...</div>} 
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                            {activeSlide == 'protocolo' && (
                                <Form onSubmit={this.saveProtocolo}>
                                    <Row>
                                        <Col sm={12}>
                                            <h4 className="mb-3">Protocolo</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Envie um protocolo através do campo abaixo (Arquivo PDF):</Form.Label>
                                                <Form.Control type="file" name="protocolo_upload" onChange={this.onChangeProtocolo} ref={this.fileInput} />
                                                <Form.Text id="formProtocoloHelper" className="text-danger">{this.state.protocoloHelper}</Form.Text>
                                                {this.state.protocolo && (
                                                    <Button variant="secondary" href={this.state.protocolo} target="_blank" style={{ marginTop: '10px' }}>
                                                        Ver Protocolo Atual
                                                    </Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar Protocolo'}                                       
                                    </Button>
                                </Form>
                            )}
                            {activeSlide == 'arquivos' && (
                                <>
                                <Form onSubmit={this.saveArquivo}>
                                    <Row>
                                        <Col sm={12}>
                                            <h4 className="mb-3">Arquivos</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Anexe abaixo um arquivo a este atendimento</Form.Label>
                                                <Form.Control type="file" name="arquivo_upload" onChange={this.onChangeArquivo} ref={this.fileInput} />
                                                <Form.Text id="formArquivoHelper" className="text-danger">{this.state.arquivoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar Arquivo'}                                       
                                    </Button>
                                </Form>
                                {arquivos.length > 0 && (
                                    <Row>
                                        <Col sm={12}>
                                            <h6 className="mt-5 mb-3">Arquivos Cadastrados</h6>
                                            <div className="arquivos-listados">
                                                {arquivos.map((arquivo) => (
                                                    <div key={arquivo.id} className="arquivo-item">
                                                        <a href={arquivo.arquivo} target="_blank" rel="noopener noreferrer" className="arquivo-link">
                                                            {arquivo.nome}
                                                        </a>
                                                        <button onClick={() => this.excluirArquivo(arquivo.id)} className="arquivo-excluir-btn">
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                                </>
                            )}
                        </div>
                    </div>
                )}
                <div className={`meeting-container ${slideOpen ? 'slide-open' : ''}`}>
                    <button className="meeting-button meeting-button-back" onClick={() => this.handleBackToPanel()}><FaArrowLeft /> Voltar ao Painel</button>
                    {this.state.isHost && (
                        <div className="button-container">
                            <button className={`meeting-button ${activeSlide === 'anotacoes' ? 'active' : ''}`} onClick={() => this.toggleSlide('anotacoes')}><FaRegStickyNote /><span>Anotações</span></button>
                            {/*<button className={`meeting-button ${activeSlide === 'protocolo' ? 'active' : ''}`} onClick={() => this.toggleSlide('protocolo')}><FaFilePdf /><span>Protocolo</span></button>*/}
                            <button className={`meeting-button ${activeSlide === 'arquivos' ? 'active' : ''}`} onClick={() => this.toggleSlide('arquivos')}><FaPaperclip /><span>Arquivos</span></button>
                        </div>
                    )}
                    <whereby-embed 
                        room={this.state.isHost ? this.state.host_url : this.state.guest_url} 
                        className="meeting-iframe"
                        displayName={`${this.state.dados_usuario.name} ${this.state.dados_usuario.last_name}`}
                        participantCount="off"
                        timer=""
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(MeetingsEdit);